<template>
    <Multiselect
        v-model="selectedProvince"
        class="form-control-lg province-select"
        :placeholder="$t('common.form.province')"
        :options="provinces"
        :searchable="true"
        :canDeselect="false"
        @search-change="autocomplete"
        ref="provinceSelect"
        @change="provinceSelected"
    />
</template>

<script>
import {nextTick} from 'vue';

import Multiselect from '@vueform/multiselect';

export default {
    name: 'ProvinceSelect',
    components: {
        Multiselect
    },
    props: ['modelValue', 'autocompleteAttribute'],
    emits: ['update:modelValue'],
    //Normally I declare methods after data, but making an exception so that the long list of provinces goes last.
    methods: {
        autocomplete: function(query) {
            if (query) {
                let matchingProvince = this.provinces.find(province => province.value === query.toUpperCase() || province.label.toUpperCase() === query.toUpperCase())
                if (matchingProvince !== undefined) {
                    this.$refs.provinceSelect.select(matchingProvince.value, matchingProvince.label);
                } else {
                    this.$refs.provinceSelect.clear();
                }
            }
        },
        provinceSelected: function(value) {
            this.$emit('update:modelValue', value);
        },
        updateAutocompleteAttribute() {
            //Hack to get the appropriate autocomplete attribute on the multiselect search.
            if (this.$attrs.id && this.autocompleteAttribute) {
                document.querySelector(`#${this.$attrs.id} .multiselect-search`).setAttribute('autocomplete', this.autocompleteAttribute);
            }
        }
    },
    mounted() {
        this.updateAutocompleteAttribute();
    },
    watch: {
        autocompleteAttribute() {
            //Let the DOM settle out and then update the autocomplete attribute.
            nextTick(() => {
                this.updateAutocompleteAttribute();
            });
        }
    },
    data() {
        return {
            selectedProvince: null,
            provinces: [
                {
                    label: 'Alberta',
                    value: 'AB',
                },
                {
                    label: 'British Columbia',
                    value: 'BC',
                },
                {
                    label: 'Manitoba',
                    value: 'MB',
                },
                {
                    label: 'New Brunswick',
                    value: 'NB',
                },
                {
                    label: 'Newfoundland & Labrador',
                    value: 'NL',
                },
                {
                    label: 'Nova Scotia',
                    value: 'NS',
                },
                {
                    label: 'Northwest Territories',
                    value: 'NT',
                },
                {
                    label: 'Nunavut',
                    value: 'NU',
                },
                {
                    label: 'Ontario',
                    value: 'ON',
                },
                {
                    label: 'Quebec',
                    value: 'QC',
                },
                {
                    label: 'Prince Edward Island',
                    value: 'PE',
                },
                {
                    label: 'Saskatchewan',
                    value: 'SK',
                },
                {
                    label: 'Yukon',
                    value: 'YT',
                },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.province-select {
    &.is-invalid {
        border-color: $danger;
    }
}
</style>